import { REQUEST_SUCCESS, REQUEST_FAIL, CLOSE_MODAL } from './actions';

const initialState = {
  displayModal: false,
  success: true,
  message: ''
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_SUCCESS:
      return {
        ...state,
        displayModal: true,
        success: true,
        message: action.message
      };
    case REQUEST_FAIL:
      return {
        ...state,
        displayModal: true,
        success: false,
        message: action.message
      };
    case CLOSE_MODAL:
      return {
        ...state,
        displayModal: false,
        message: ''
      };
    default:
      return state;
  }
};

export default reducer;
